import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";

const StorySection = () => {
  const milestones = [
    {
      year: "2012",
      title: "Foundation",
      description:
        "Started with a vision to bridge the gap between IT solutions and brand development",
      icon: "Rocket",
      color: "from-cyan-500 to-blue-600",
    },
    {
      year: "2015",
      title: "Microsoft Partnership",
      description:
        "Became certified Microsoft partner, expanding enterprise capabilities",
      icon: "Award",
      color: "from-blue-500 to-blue-800",
    },
    {
      year: "2018",
      title: "100+ Clients",
      description:
        "Crossed milestone of serving 100 satisfied clients across industries",
      icon: "Users",
      color: "from-blue-500 to-emerald-600",
    },
    {
      year: "2020",
      title: "Digital Transformation",
      description:
        "Pivoted to comprehensive digital transformation services during pandemic",
      icon: "Zap",
      color: "from-blue-500 to-blue-900",
    },
    {
      year: "2022",
      title: "Cybersecurity Focus",
      description:
        "Launched dedicated cybersecurity division with Acronis partnership",
      icon: "Shield",
      color: "from-blue-500 to-blue-900",
    },
    {
      year: "2025",
      title: "Innovation Leader",
      description:
        "Recognized as leading IT & branding solutions provider with 196+ clients",
      icon: "TrendingUp",
      color: "from-indigo-500 to-violet-600",
    },
  ];

  const achievements = [
    { value: "13+", label: "Years Experience", icon: "Calendar" },
    { value: "196+", label: "Happy Clients", icon: "Users" },
    { value: "223+", label: "Projects Delivered", icon: "CheckCircle" },
    { value: "98%", label: "Retention Rate", icon: "Heart" },
  ];

  return (
    <section className="relative bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-white py-16 md:py-24 lg:py-32 px-4 md:px-6 lg:px-8 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Header Section */}
      
        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start mb-20">
          {/* Left Column - Story */}
          <div className="space-y-8">
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/20 shadow-xl">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <Icon name="Star" size={24} className="text-blue-400" />
                Our Origin Story
              </h3>
              <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">
                Founded in 2012, Orator Hype began with a simple yet powerful vision — to build a company
                where cutting-edge IT and branding solutions work seamlessly together. We recognized early
                on that businesses need more than just technical expertise; they need a strategic partner who
                understands the complete digital ecosystem.
              </p>
              <p className="text-white/80 text-base md:text-lg leading-relaxed mb-4">
                Over the years, we have evolved from a small team of passionate technologists and creatives
                into a full-scale digital transformation partner. Our journey has been driven by continuous
                innovation, strategic partnerships with industry leaders such as Microsoft, Zoho, and Acronis,
                and an unwavering commitment to delivering measurable results for our clients.
              </p>
              <p className="text-white/80 text-base md:text-lg leading-relaxed">
                Today, we proudly serve 196+ businesses and have successfully delivered over 223 projects.
                Our core values revolve around confidence, growth, and long-term partnerships — helping
                businesses not just survive, but thrive in an increasingly digital world.
              </p>
            </div>

            {/* <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/20 shadow-xl">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <Icon name="Target" size={24} className="text-cyan-400" />
                Strategic Evolution & Expansion
              </h3>
              <p className="text-white/80 text-base md:text-lg leading-relaxed">
                While Orator Hype was officially registered as a corporate entity in Mumbai in 2025, our
                leadership team brings years of prior experience across IT and branding projects in West
                Bengal. With deep industry expertise and a strong execution mindset, we expanded into
                Mumbai to scale our vision and serve a broader market.
              </p>
              <div className="mt-4 flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Icon name="MapPin" size={18} className="text-cyan-300" />
                  <span className="text-white/80 text-sm">West Bengal Roots</span>
                </div>
                <div className="h-4 w-px bg-white/20"></div>
                <div className="flex items-center gap-2">
                  <Icon name="Building" size={18} className="text-blue-300" />
                  <span className="text-white/80 text-sm">Mumbai Expansion</span>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Column - Image & Stats */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-white/20 transform hover:scale-[1.02] transition-transform duration-300">
              <Image
                src="/assets/Delivering.png"
                alt="Diverse team of IT professionals and creative designers collaborating in modern office space with laptops and digital screens showing project work"
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-lg">
                    <Icon name="TrendingUp" size={28} color="#ffffff" />
                  </div>
                  <div>
                    <p className="text-3xl md:text-4xl font-bold text-white">
                      98%
                    </p>
                    <p className="text-white/80 text-sm md:text-base">
                      Client Retention Rate
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-xl rounded-2xl p-6 shadow-2xl border border-white/20">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                  196+
                </div>
                <div className="text-white/80 text-sm">Businesses Served</div>
              </div>
            </div>
          </div>
        </div>

        {/* Modern Timeline */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Growth Journey</span>
            </h3>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Milestones that define our evolution and commitment to excellence
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-cyan-500 via-blue-500 to-pink-500"></div>

            <div className="space-y-0">
              {milestones.map((milestone, index) => (
                <div
                  key={milestone.year}
                  className={`relative flex items-center justify-center mb-16 ${
                    index % 2 === 0 ? "flex-row" : "flex-row"
                  }`}
                >
                  {/* Left Side Content */}
                  <div className={`w-1/2 ${index % 2 === 0 ? "pr-12 text-right" : "order-last pl-12 text-left"}`}>
                    <div className={`inline-block ${
                      index % 2 === 0 ? "mr-0" : "ml-0"
                    }`}>
                      <div className={`bg-gradient-to-br ${milestone.color} backdrop-blur-md rounded-2xl p-6 border border-white/20 shadow-xl transform hover:scale-105 transition-all duration-300 max-w-md`}>
                        <div className="flex items-center gap-4 mb-4">
                          <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${milestone.color} flex items-center justify-center shadow-lg`}>
                            <Icon name={milestone.icon} size={24} color="#ffffff" />
                          </div>
                          <div>
                            <span className="text-2xl font-bold text-white block">
                              {milestone.year}
                            </span>
                            <h4 className="text-xl font-bold text-white">
                              {milestone.title}
                            </h4>
                          </div>
                        </div>
                        <p className="text-white/80 text-base leading-relaxed">
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Timeline Node */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 rounded-full bg-gradient-to-br from-cyan-500 to-blue-500 border-4 border-[#1a1f2e] shadow-lg z-10"></div>

                  {/* Right Side Content - Empty for symmetry */}
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="text-center bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-pink-500/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20">
          <Icon name="Quote" size={48} className="text-white/30 mx-auto mb-6" />
          <h4 className="text-xl md:text-2xl lg:text-3xl font-bold text-white mb-6">
            While Orator Hype was officially registered as a corporate entity in Mumbai in 2025,
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-blue-300">
              {" "}our leadership brings decades of collective experience
            </span>
          </h4>
          <p className="text-white/80 text-lg max-w-4xl mx-auto">
            With deep industry expertise across West Bengal and now scaling in Mumbai,
            we continue to help businesses not just survive, but thrive in an increasingly digital world.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StorySection;